import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { useEffect } from 'react';

export function AutoFocusStartPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      $getRoot().selectStart();
    });
    const rootElement = editor.getRootElement();
    if (rootElement) {
      rootElement.focus({ preventScroll: true });
    }
  }, [editor]);

  return null;
}
